import { Megaphone } from "lucide-react";
// "Welcome to #channel" empty-state shown when a channel has no messages yet.
type EmptyChannelNoticeProps = {
  channelType?: string;
  channelName: string;
};

function EmptyChannelNotice({ channelType, channelName }: EmptyChannelNoticeProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-12 px-6 text-center select-none pointer-events-none">
      <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white/5 text-2xl">
        {channelType === 'announcement' ? <Megaphone className="h-6 w-6" strokeWidth={1.5} /> : '#'}
      </div>
      <div className="text-sm font-medium text-fg-2">
        Welcome to #{channelName}
      </div>
      <div className="max-w-xs text-xs text-fg-3 leading-relaxed">
        {channelType === 'announcement'
          ? 'This is an announcement channel. Only space owners can post here.'
          : 'This is the beginning of this channel. Send a message to get the conversation started.'}
      </div>
    </div>
  );
}

export default EmptyChannelNotice;
